/**
 * LES ROUTES DU MODULE SOUS LA FICHE D'UN BÂTIMENT (LOT F3), lues par le
 * générateur du routeur (`scripts/generate-router-plugin.js`). Le module n'est
 * pas dans `BUILDING_SHELL_MODULE_ORDER` : il passe en dernier.
 */
import type { RouteRecordRaw } from "vue-router"
import { enfantsSurveillance } from "./utils/routesEquipement"

export const buildingShellChildren: RouteRecordRaw[] =
    enfantsSurveillance("building")
